import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import * as L from "leaflet";
import 'leaflet-fullscreen';
import { LocationCoordinates } from "../../../common/interfaces/global-interfaces";

@Component({
  selector: 'app-view-map',
  templateUrl: './view-map.component.html',
  styleUrls: ['./view-map.component.scss']
})
export class ViewMapComponent implements OnInit, OnChanges {

  @Input({ required: true }) mapCoordinates: LocationCoordinates[] = [];
  @Input() isGetLocation: boolean = false;
  @Input() zoomOutToCountry: boolean = false;

  @Output() selectedLocation = new EventEmitter<{ lat: number, lng: number; title: string }>();

  coordinates: [number, number][] = [];
  titles: string[] = [];
  private map: L.Map;

  constructor() {}

  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges): void {
    // Clear previous coordinates and titles
    this.coordinates = [];
    this.titles = [];

    // Extract coordinates and titles
    if (this.mapCoordinates) {
      this.mapCoordinates.forEach(lc => {
        if (lc?.latitude && lc?.longitude) {
          this.coordinates.push([
            parseFloat(lc.latitude),
            parseFloat(lc.longitude)
          ]);
          this.titles.push(lc.title);
        }
      });

      if (this.map) {
        this.map.remove(); // Remove previous map instance if it exists
      }

      this.initializeMap();
    }
  }

  initializeMap() {
    // Initialize map
    this.map = L.map('map-view').setView(this.zoomOutToCountry ? [-6.830373, 37.670589] : this.coordinates[0], this.zoomOutToCountry ? 5 : 12);

    // Add tile layer
    L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 19,
    }).addTo(this.map);

    // Add fullscreen control
    L.control.fullscreen({
      position: 'topright',
      title: 'Show fullscreen',
      titleCancel: 'Exit fullscreen',
    }).addTo(this.map);

    // Add markers
    this.coordinates.forEach((coord, index) => {
      const marker = L.marker(coord).bindPopup(this.titles[index]);
      marker.addTo(this.map);
      marker.on('click', () => {
        this.map.setView(coord, 15); // Zoom in to marker when clicked
        this.selectedLocation.emit({
          lat: coord[0],
          lng: coord[1],
          title: this.titles[index]
        });
      });
    });

    // Adjust bounds to fit all markers
    if (this.coordinates.length) {
      const bounds = L.latLngBounds(this.coordinates);
      this.map.fitBounds(bounds, { padding: [20, 20] });
    }
  }
}